/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Installation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Installation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Installation",
  text = "Setting up Google Tag Manger to relay from the leads app embed code"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let selectedConfigurationIdValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.leadsLink,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let selectedConfigurationIdValueData1 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.leadsLink,
})
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let selectedConfigurationIdValueData2 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.embedCode,
})
let selectedConfigurationIdValueData3 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.embedCode,
})
let selectedConfigurationIdValueData4 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.trackingCode,
})
let selectedConfigurationIdValueData5 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.trackingCode,
})
  return (<React.Fragment
>
<div
  data-testid="Installation.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z2tbWsi': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginTop={dtSpaceM}
 text="Direct Link"
/>
<div
  data-testid="Installation.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginTop={dtSpaceXs}
 data="selected.configuration_id"
 format="helpers.js leadsLink"
 text={selectedConfigurationIdValueData}
 goTo={selectedConfigurationIdValueData}
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 marginTop={6}
 data="selected.configuration_id"
 format="helpers.js leadsLink"
 value={selectedConfigurationIdValueData1}
 text={selectedConfigurationIdValueData1}
/>
</div>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 backgroundColor={dtColorsNeutral100}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Embed code"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
 height={60}
 alignItems="flex-start"
>
{childProps => (
<React.Fragment>
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 disabled={true}
 data="selected.configuration_id"
 format="helpers.js embedCode"
 value={selectedConfigurationIdValueData2}
/>
<Copy
{...childProps}
  viewPath={`${viewPath}/Copy`}
 useRaw={true}
 data="selected.configuration_id"
 format="helpers.js embedCode"
 value={selectedConfigurationIdValueData3}
 text={selectedConfigurationIdValueData3}
/>
</React.Fragment>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginTop={dtSpaceM}
 text="Tracking with Google Analytics (optional)"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXs}
 text="This depends on your website and tracking setup, and may need some development and Google Analytics expertise."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 text="It is possible to listen to pageView events from an embedded Leads app. Adding the code below to the page on which you embed the Leads app, relays these messages to your on-page Google Analytics data layer."
/>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 backgroundColor={dtColorsNeutral100}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Tracking code"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
 height={220}
 alignItems="flex-start"
>
{childProps => (
<React.Fragment>
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 disabled={true}
 data="selected.configuration_id"
 format="helpers.js trackingCode"
 value={selectedConfigurationIdValueData4}
/>
<Copy
{...childProps}
  viewPath={`${viewPath}/Copy`}
 useRaw={true}
 data="selected.configuration_id"
 format="helpers.js trackingCode"
 value={selectedConfigurationIdValueData5}
 text={selectedConfigurationIdValueData5}
/>
</React.Fragment>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 level="h4"
 marginTop={dtSpaceM}
 text="Further instructions for Google Tag Manager are available here:"
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginTop={dtSpaceXs}
 target="_blank"
 text={text}
 goTo="https://drive.google.com/file/d/1vB09krAHU6x53O7EuiIBgTvsV1qXeytL/view"
/>
</div>
{children}
</React.Fragment>)
}